import classNames from 'classnames';
import { Fragment } from 'react';

import ErrorBoundary from '../components/ErrorBoundary';
import { InnerContentScrollbars } from '../components/layout/InnerContentScrollbars';
import {
  HorizontalTrackTypes,
  Scrollbars,
} from '../components/layout/Scrollbars';
import AccountBottomBar from '../widgets/AccountBottomBar';
import { AccountDropdownDialogs } from '../widgets/AccountDropdown';
import LoggedFooter from '../widgets/LoggedFooter';
import MainMenuDrawer from '../widgets/MainMenuDrawer';
import MainMenuHeader from '../widgets/MainMenuHeader';
import { useBaseLoggedPageStyles } from './BaseLoggedPage.styles';

export default function BaseLoggedPage({
  id,
  className,
  innerContentClassName,
  children,
  wrapInScrollbar,
  leftSideContent,
}) {
  const { styles } = useBaseLoggedPageStyles();
  const Wrapper = wrapInScrollbar ? InnerContentScrollbars : Fragment;
  return (
    <Scrollbars
      id={id}
      className={classNames(styles.root, className)}
      horizontal={HorizontalTrackTypes.BOTTOM}
      spaceOutside
    >
      <div className={styles.content}>
        <MainMenuHeader />
        <AccountDropdownDialogs />
        <MainMenuDrawer />
        <div className={classNames(styles.innerContent, innerContentClassName)}>
          <Wrapper>
            <ErrorBoundary messageId="error.render.page">
              {children}
            </ErrorBoundary>
          </Wrapper>
        </div>
        <LoggedFooter />
        <AccountBottomBar leftSideContent={leftSideContent} />
      </div>
    </Scrollbars>
  );
}
